import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useReadingTime = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());
  const pagePathRef = useRef(location.pathname);

  useEffect(() => {
    startTimeRef.current = Date.now();
    pagePathRef.current = location.pathname;

    const sendReadingTime = () => {
      const timeSpent = Math.round((Date.now() - startTimeRef.current) / 1000);
      if (timeSpent > 2 && window.gtag) {
        window.gtag('event', 'reading_time', {
          page_path: pagePathRef.current,
          time_seconds: timeSpent,
        });
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        sendReadingTime();
      } else {
        startTimeRef.current = Date.now();
      }
    };

    const handleBeforeUnload = () => {
      sendReadingTime();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      sendReadingTime();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location.pathname]);
};

export default useReadingTime;
